import { render, staticRenderFns } from "./Pmd.vue?vue&type=template&id=efe84276&scoped=true&"
import script from "./Pmd.vue?vue&type=script&lang=js&"
export * from "./Pmd.vue?vue&type=script&lang=js&"
import style0 from "./Pmd.vue?vue&type=style&index=0&id=efe84276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe84276",
  null
  
)

export default component.exports